const SearchIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    className={className}
    aria-hidden='true'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.13142 2C3.8497 2 2 3.8497 2 6.13142C2 8.41314 3.8497 10.2628 6.13142 10.2628C8.41314 10.2628 10.2628 8.41314 10.2628 6.13142C10.2628 3.8497 8.41314 2 6.13142 2ZM0 6.13142C0 2.74513 2.74513 0 6.13142 0C9.51771 0 12.2628 2.74513 12.2628 6.13142C12.2628 7.3081 11.9314 8.40737 11.3567 9.34095L14.406 12.3902C14.7965 12.7808 14.7965 13.4139 14.406 13.8045C14.0155 14.195 13.3823 14.195 12.9918 13.8045L10.0417 10.8543C8.98036 11.734 7.61764 12.2628 6.13142 12.2628C2.74513 12.2628 0 9.51771 0 6.13142Z'
      fill='currentColor'
    />
  </svg>
);

export default SearchIcon;
